<template>
  <avs-card>
    <template #title>
      <v-card-title class="pl-0">{{ $t("Demande") }} #{{ redemption?.uuid || redemption?.id }}</v-card-title>
    </template>
    <template #content>
      <v-container>
        <v-row>
          <v-col cols="6">
            <div><strong>{{ $t("Utilisateur") }}:</strong> {{ redemption?.user_fullname || redemption?.user_username || redemption?.user }}</div>
            <div><strong>{{ $t("Entreprise") }}:</strong> {{ redemption?.company_name || redemption?.company }}</div>
            <div><strong>{{ $t("Type") }}:</strong> {{ redemption?.request_type }}</div>
            <div><strong>{{ $t("Points") }}:</strong> {{ redemption?.points_requested }}</div>
          </v-col>
          <v-col cols="6">
            <div v-if="redemption?.request_type==='cash'">
              <strong>{{ $t("Montant") }}:</strong> {{ formatNumber(redemption?.payout_amount) }} XOF
            </div>
            <div v-else>
              <strong>{{ $t("Produit") }}:</strong> {{ redemption?.product_name || redemption?.product }}
              <br>
              <strong>{{ $t("Litres autorisés") }}:</strong> {{ redemption?.liters_authorized }} L
              <div v-if="redemption?.voucher">#BON: {{ redemption?.voucher }}</div>
            </div>
            <div><strong>{{ $t("Statut") }}:</strong> {{ redemption?.status }}</div>
          </v-col>
        </v-row>

        <v-divider class="my-4" />

        <!-- <v-row v-if="redemption?.status==='pending'">
          <v-col cols="12" class="text-right">
            <v-btn color="success" class="mr-3" @click="$emit('approved')"><v-icon left>mdi-check</v-icon>{{ $t('commons.accept') }}</v-btn>
            <v-btn color="error" @click="$emit('rejected')"><v-icon left>mdi-close</v-icon>{{ $t('commons.reject') }}</v-btn>
          </v-col>
        </v-row>

        <v-row v-else-if="redemption?.status==='approved' && redemption?.request_type==='cash'">
          <v-col cols="12" class="d-flex align-center">
            <v-text-field v-model="reference" :label="$t('Référence de paiement')" dense hide-details class="mr-4" />
            <v-spacer />
            <v-btn color="success" @click="$emit('paid', reference)"><v-icon left>mdi-cash-multiple</v-icon>{{ $t('Valider le paiement') }}</v-btn>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col cols="12" class="text-right">
            <v-btn text @click="$emit('cancel')">{{ $t('commons.close') }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </avs-card>
</template>

<script>
export default {
  name: "RedemptionReviewDialog",
  props: { value: { type: Object, required: true } },
  data(){ return { reference: "" }; },
  computed: {
    redemption(){ return this.value; }
  },
  methods: {
    formatNumber(v){ return (v || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "); }
  }
};
</script>
